import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import Loadable from 'react-loadable'

import Loader from 'components/LayoutComponents/Loader'
import IndexLayout from 'layouts'
import NotFoundPage from 'pages/404'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => <Loader />,
  })

const routes = [
  {
    path: '/user/login',
    component: loadable(() => import('pages/login')),
    exact: true,
  },
  {
    path: '/user/forgot',
    component: loadable(() => import('pages/forgot')),
    exact: true,
  },
  {
    path: '/user/registration',
    component: loadable(() => import('pages/registration')),
    exact: true,
  },
  {
    path: '/user/congratulation',
    component: loadable(() => import('pages/congratulation')),
    exact: true,
  },
  {
    path: '/main',
    component: loadable(() => import('pages/main')),
  },
  {
    path: '/profile',
    component: loadable(() => import('pages/profile')),
    exact: true,
  },
]

class Router extends React.Component {
  render() {
    const { history } = this.props
    return (
      <ConnectedRouter history={history}>
        <IndexLayout>
          <Switch>
            <Route exact path="/" render={() => <Redirect to="/main" />} />
            {routes.map(route => (
              <Route
                path={route.path}
                component={route.component}
                key={route.path}
                exact={route.exact}
              />
            ))}
            <Route component={NotFoundPage} />
          </Switch>
        </IndexLayout>
      </ConnectedRouter>
    )
  }
}

export default Router
